import React from 'react';
import ReactToPrint from 'react-to-print';
import { withAlert } from 'react-alert';
import OrderReady from './order-ready';
import { getButtonText, getTextClass, isButtonDisabled, isOrderReady } from './functions';
import useNetworkContext from '../../contexts/network.context';
import useLayoutContext from '../../contexts/layout.context';

// TODO :: Refactor card button to render different buttons instead of action manipulation
const CardButton = ({
  actionDisabled,
  status,
  paid,
  packagingComplete,
  actionClick,
  actionLoading,
  receiptRef,
  isPickup,
  order = {},
  alert,
  disableReceipt
}) => {
  const { disableNetworkActions } = useNetworkContext();
  const { permissions } = useLayoutContext();
  const { canPrintReceipt, showIfOrderIsReady } = permissions;
  const disabled =
    isButtonDisabled({ actionDisabled, packagingComplete, status }) || disableNetworkActions;

  return isOrderReady({ showIfOrderIsReady, status }) ? (
    <OrderReady
      order={order}
      showSuccess={(message) => alert?.show(message, { type: 'success' })}
    />
  ) : (
    <a
      id='cardButton'
      onClick={() => {
        if (!disabled) {
          actionClick?.();
        }
      }}
      className='flex flex-col justify-start items-end'>
      {canPrintReceipt && !disableReceipt ? (
        <ReactToPrint
          trigger={() => (
            <button className='rounded-full bg-white px-[29.5px] py-[7px]' disabled={disabled}>
              <span className={getTextClass({ packagingComplete, status, actionDisabled })}>
                {getButtonText({ status, actionDisabled, isPickup, packagingComplete, paid })}
                {actionLoading ? '...' : ''}
              </span>
            </button>
          )}
          content={() => receiptRef.current}
        />
      ) : (
        <button className='rounded-full bg-white px-[29.5px] py-[7px]' disabled={disabled}>
          <span className={getTextClass({ packagingComplete, status, actionDisabled })}>
            {getButtonText({ status, actionDisabled, isPickup, packagingComplete, paid })}
            {actionLoading ? '...' : ''}
          </span>
        </button>
      )}
    </a>
  );
};

export default withAlert()(CardButton);
